import i18n from 'i18n-react';

// Function to load translations based on locale
function loadTranslations(locale) {
  const translations = require.context('../../src', true, /\.json$/);
  let localeTranslations = {};

  translations.keys().forEach((key) => {
    if (key.endsWith(`/${locale}.json`)) {
      const translation = translations(key);
      localeTranslations = { ...localeTranslations, ...translation };
    }
  });
  return localeTranslations;
}

// Set up i18n configuration
function configureI18n(locale) {
  // T.setTexts({ ...T.texts, ...language.getDictionary() }, { MDFlavor: 1 });
  i18n.setTexts({...i18n.texts,...loadTranslations(locale)}, { MDFlavor: 1 });
}

export default configureI18n;
